// Dependencies
import { FC } from "react";

// Utils
import { alpha } from "@mui/material";

// Styles
import { StyledTag } from "./Tag.styled";

interface TagProps {
  label?: string;
  color: string;
}

const Tag: FC<TagProps> = ({ label, color = "ffffff" }) => {
  return (
    <StyledTag
      sx={{
        color: color,
        borderColor: color,
        backgroundColor: alpha(color, 0.2),
      }}
    >
      {label}
    </StyledTag>
  );
};

export default Tag;
